import { StyleSheet } from 'react-native';
import { PALETTE } from '../../constants';

export default StyleSheet.create({
  root: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  trigger: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  selectedPortfolio: {
    color: PALETTE.primaryText,
    marginRight: 15,
  },
  option: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingRight: 20,
  },
});
